import React, { useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Button, Spinner } from "../";
import { request } from "../../api";

import "./slider.scss";

const Video = ({ poster, mp4src, ogvsrc, webmsrc }) => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <video
        loop
        muted
        poster={poster ? `${request}/${poster}` : null}
        preload="metadata"
        playsInline
        autoPlay
        onLoadedData={() => {
          setLoading(false);
        }}
      >
        {mp4src && <source src={`${request}/${mp4src}`} type="video/mp4" />}
        {/* {ogvsrc && <source src={`${request}/${ogvsrc}`} type="video/ogg" />} */}
        {webmsrc && <source src={`${request}/${webmsrc}`} type="video/webm" />}
        Ваш браузер не поддерживает HTML5 видео.
      </video>

      {(loading && !poster) && (
        <div className="main-slider__spinner">
          <Spinner />
        </div>
      )}
    </>
  );
};

const MainSlider = ({ slides, onButtonClick, showBtn = true }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const slides_list =
    slides &&
    slides.map((item) => {
      const slide_img = (
        <img
          src={
            item.slide_image || item.image
              ? `${request}/${
                  item.slide_image ? item.slide_image.url : item.image.url
                }`
              : ""
          }
          alt=""
        />
      );

      return (
        <SwiperSlide key={item.id}>
          <Link to={item.link} className="main-slider-item">
            {item.slide_video?.url ? (
              <Video
                poster={item.slide_image?.url}
                mp4src={item.slide_video?.mp4?.url}
                ogvsrc={item.slide_video?.ogv?.url}
                webmsrc={item.slide_video?.webm?.url}
              />
            ) : (
              slide_img
            )}
          </Link>
        </SwiperSlide>
      );
    });

  const sliderRef = useRef();

  return (
    <div className="main-slider-wrapper">
      <Swiper
        ref={sliderRef}
        className="main-slider__swiper"
        slidesPerView={1}
        // autoHeight

        speed={2500}
        autoplay={{
          delay: 5000,
        }}
        modules={[Pagination, Autoplay]}
        loop
        pagination={{
          el: ".main-slider__pagination",
          clickable: true,
        }}
        spaceBetween={16}
        breakpoints={{
          980: {
            spaceBetween: 24,
          },
          1281: {
            spaceBetween: 40,
          },
        }}
        onSlideChange={(i) => {
          const slideIndex = i.realIndex;

          setActiveSlide(slideIndex);

          // videos.current.forEach((item) => {
          //   item.pause();

          //   console.log(`остановил видео ${slideIndex}`)
          // });

          // if (videos.current[slideIndex]) {
          //   videos.current[slideIndex].play();
          //   console.log(`стартанул видео ${slideIndex}`)
          // }
        }}

        // onInit={(i) => {
        //   const slideIndex = i.realIndex;

        //   if (videos.current[slideIndex]) {
        //     videos.current[slideIndex].play();
        //     console.log(`стартанул видео ${slideIndex}`)
        //   }
        // }}
      >
        {slides_list}
      </Swiper>

      <div className="main-slider-panel">
        {slides && (
          <div className="main-slider-panel_title-wrapper">
            <Link
              to={slides[activeSlide].link}
              className="main-slider-panel_title"
            >
              {slides[activeSlide].title}
            </Link>
          </div>
        )}

        <div className="main-slider__pagination"></div>

        {showBtn && (
          <Button
            isAccent={true}
            className="main-slider-button"
            onClick={() => onButtonClick()}
          >
            Оставить заявку
          </Button>
        )}
      </div>
    </div>
  );
};

export default MainSlider;
